import root from 'window-or-global';
import parse from 'url-parse';
import Url from '../constants/Url';
import {ChannelStatus, ErrorCode, SocialPlatform} from '../../shared/types';

export const setAuthResponseEvent = ({
    channelStatus = null,
    errors = null,
    impossibleCheck = false,
    authState = null,
    followers = null,
    valid = null
}) => {
    return root.document.dispatchEvent(
        /*global CustomEvent*/
        new CustomEvent('setAuthResponse', {
            bubbles: true,
            detail: {
                channelStatus,
                errors,
                impossibleCheck,
                authState,
                followers,
                valid
            }
        })
    );
};

export const getLogoutUrl = ({platform = null, accessToken = null}) => {
    if (!platform || !accessToken) return null;

    const urls = Url();

    const platformsMap = {
        [SocialPlatform.FACEBOOK]: `https://www.facebook.com/logout.php?next=${urls.SOCIAL_LOGOUT}&access_token=${accessToken}`,
        [SocialPlatform.INSTAGRAM]: `https://www.facebook.com/logout.php?next=${urls.SOCIAL_LOGOUT}&access_token=${accessToken}`
    };

    return platformsMap[platform] || null;
};

const urlRegPrefix = /^https:\/\/(www.)?/;
const urlRegPostfix = /\/([\w\d\-_.@]{1,})([\w\d&/\-_.@&?=%]{1,})?$/i;

const platformArray = [
    {
        platform: SocialPlatform.YOUTUBE_CHANNEL,
        platformReg: `${urlRegPrefix.source}youtube.(ca|com)/channel${urlRegPostfix.source}`
    },
    {
        platform: SocialPlatform.TWITCH_CHANNEL,
        platformReg: `${urlRegPrefix.source}twitch.(tv|com)${urlRegPostfix.source}`
    },
    {
        platform: SocialPlatform.FACEBOOK,
        platformReg: `${urlRegPrefix.source}facebook.(ca|com)${urlRegPostfix.source}`
    },
    {
        platform: SocialPlatform.VK,
        platformReg: `${urlRegPrefix.source}vk.com${urlRegPostfix.source}`
    },
    {
        platform: SocialPlatform.TWITTER,
        platformReg: `${urlRegPrefix.source}twitter.com${urlRegPostfix.source}`
    },
    {
        platform: SocialPlatform.INSTAGRAM,
        platformReg: `${urlRegPrefix.source}instagram.(ca|com)${urlRegPostfix.source}`
    }
];

export const parseSocialLink = (url = null) => {
    const result = {
        platform: null,
        channelId: null
    };

    if (!url) return result;

    platformArray.some(({platform, platformReg}) => {
        const matchesNetwork = new RegExp(platformReg, 'i').exec(url);
        if (!matchesNetwork) return null;

        result.platform = platform;
        result.channelId = matchesNetwork[matchesNetwork.length - 2] || null;

        // treat vk differently
        if (
            platform === SocialPlatform.VK &&
            typeof result.channelId === 'string' &&
            result.channelId.startsWith('public')
        ) {
            const vkPublicChannelId = result.channelId.slice(6);
            if (Number.parseInt(vkPublicChannelId) === +vkPublicChannelId) {
                result.channelId = vkPublicChannelId;
            }
        }
        // break loop when complete
        return result.platform && result.channelId;
    });

    return result;
};

export const formatChannelUrl = (url): string => {
    const parsedUrl = parse(url.trim(), {});

    if (!parsedUrl.hostname) {
        return null;
    }

    const hostname = parsedUrl.hostname.toLowerCase();

    let newHostname;

    if (hostname.indexOf('www.') !== 0) {
        newHostname = `www.${hostname}`;
    } else {
        newHostname = hostname;
    }

    return `https://${newHostname}${parsedUrl.pathname}`;
};

export const clientAuthError = (errorCode?: string) => {
    return {
        channelStatus: ChannelStatus.ERROR,
        violations: [errorCode || ErrorCode.SOCIAL_CHANNEL_SOMETHING_WRONG]
    };
};
